import React, { lazy, Suspense, Fragment } from "react"
import { Route } from "react-router-dom"
import { PATH } from "src/utils/constants/path.constants"
import Loading from "src/components/Loading/Loading"
import AuthResolver from "src/resolvers/AuthResolver"
import { LoginGuard } from "src/guards/Loginguard"
import { useAppSelector } from "src/hooks/redux"

const Login = lazy(() => import("src/pages/Login/Login"))
export default function LoginRoutes() {
  const isAuthenticated = useAppSelector(state => state.app.isAuthenticated)
  return (
    <Fragment>
      <LoginGuard path={PATH.LOGIN}>
        <Suspense fallback={<Loading />}>
          <Login />
        </Suspense>
      </LoginGuard>
      {!isAuthenticated && <Route path={PATH.HOME} component={AuthResolver} />}
    </Fragment>
  )
}
